'use client';

import { BottomSheet } from './bottom-sheet';
import { Modal } from './modal';
import { TagManageContent, type ManageableLabel } from './tag-manage-content';
import type { TagColorId } from './tag-colors';

export interface TagManagerProps {
  open: boolean;
  onClose: () => void;
  labels: ManageableLabel[];
  counts: Record<string, number>;
  onRename: (oldName: string, newName: string) => void;
  onRecolor: (name: string, color: TagColorId) => void;
  onReorder: (orderedNames: string[]) => void;
  onCreate: (name: string, color: TagColorId) => void;
  onDelete: (name: string) => void;
  /** Titel der Verwalten-Shell (Default „Labels verwalten"). */
  title?: string;
  /** Substantiv für den Verwendungszähler in der Lösch-Bestätigung. */
  usageNoun?: { singular: string; plural: string };
}

/**
 * „Labels verwalten" — ersetzt den früheren Inline-Verwalten-Modus. Mobil als
 * BottomSheet (Design „Bottomup-Menü"), auf Desktop als zentriertes Modal mit
 * identischem Inhalt. Beide Shells werden gerendert und per Tailwind je Viewport
 * ein-/ausgeblendet — analog zum Aktionsmenü (Sheet + Popover).
 */
export function TagManager({
  open,
  onClose,
  title = 'Labels verwalten',
  ...content
}: TagManagerProps) {
  return (
    <>
      {/* Mobil: BottomSheet (intern bereits md:hidden) */}
      <BottomSheet
        open={open}
        onClose={onClose}
        ariaLabel={title}
        header={
          <div className="px-4 py-3 pr-12">
            <h2 className="text-base font-semibold text-gray-900">{title}</h2>
          </div>
        }
      >
        <TagManageContent {...content} />
      </BottomSheet>

      {/* Desktop: zentriertes Modal */}
      <div className="hidden md:block">
        <Modal
          isOpen={open}
          onClose={onClose}
          title={title}
          className="max-w-md"
          bodyClassName="overflow-y-auto"
        >
          <TagManageContent {...content} />
        </Modal>
      </div>
    </>
  );
}
